export default {
  permissions: [],
  permission: {},
  permissionHelpers: {}
}



// WEBPACK FOOTER //
// ./src/components/permission/store/state.js